import { SET_BASE_PATH, CLEAR_BASE_PATH, SET_IS_SHOW_MODAL_BACKDROP, SET_IS_LOADING } from '@/actions/types';

const initialState = {
  isShowModalBackdrop: false,
  isLoading: false,
  basePath: ''
};

export default function common(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_IS_LOADING:
      return { 
        ...state,
        isLoading: payload
      }
    case SET_IS_SHOW_MODAL_BACKDROP:
      return { 
        ...state,
        isShowModalBackdrop: payload
      }
    case SET_BASE_PATH:
      return { 
        ...state,
        basePath: payload.replace('/','') 
      }
    case CLEAR_BASE_PATH:
      return { 
        ...state,
        basePath: '' 
      }
    default:
      return state;
  }
}
